export const isString = (arg) => typeof arg === 'string';
